<div class="row m-0 h-100 login_container">

  <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 setPadding ">
    <div class="row m-0 h-100 login">

      <div class="row_tab">
        <app-header></app-header>
        <div class="mainform">
          <div class="title col-12 align-self-center">
            <h3 class="mb-4">LOGIN TO YOUR ACCOUNT</h3>
          </div>
          <form class="blue_rectangle" [formGroup]='Two_fact_code'>
            <div class="row m-0">
              <div class="col-12 p-0 email">
                <mat-form-field class="col-12">
                  <input type="number" matInput placeholder="Enter the code Here" formControlName="Code">
                  <mat-error *ngIf="Two_fact_code.get('Code').errors?.required">Please enter a valid code</mat-error>
                </mat-form-field>
              </div>
              <div class="buttonpadding">
                <button class="btn_padding"  mat-raised-button
                  color="primaryCus" [disabled]="!Two_fact_code.valid" (click) ="submitAuthData()">Submit</button>
                  &nbsp;
                  <button mat-raised-button color="primaryStrCus" type="button" (click)="logOut()"
                  class="frwd_button control_buttons  col-6">Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      

    </div>
  </div>
  <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 pos-rel h-100">
    <div class="row h-100 align-items-center">
      <div class="phoneimg">
        <img src="assets/images/googleauth.png" class="img-fluid">
      </div>
    </div>
    <div class="copyright pos-abs text-center">
      <p class="mb-4 fontwhite">
        <!-- © {{year}} StandardC. All Rights Reserved -->
      </p>
    </div>

  </div>
  <div class="col-12">
    <app-footer></app-footer>

  </div>
</div>